import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/daily-record',
    name: 'DailyRecord',
    component: () => import('../views/DailyRecord.vue')
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: () => import('../views/WelcomePage.vue')
  },
  {
    path: '/video',
    name: 'Video',
    component: () => import('../views/VideoPage.vue')
  },
  {
    path: '/company-ppt',
    name: 'CompanyPpt',
    component: () => import('../views/CompanyPptPage.vue')
  },
  {
    path: '/menu',
    name: 'Menu',
    component: () => import('../views/MenuPage.vue')
  },
  {
    path: '/dish-rating',
    name: 'DishRating',
    component: () => import('../views/DishRating.vue')
  }
]

const TITLE_MAP = {
  Welcome: '欢迎语',
  DailyRecord: '食安大屏',
  Menu: '菜品',
  Video: '视频监控',
  CompanyPpt: '公司ppt',
  DishRating: '菜品评价'
}

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  document.title = TITLE_MAP[to.name] || '食安大屏'
  const params = new URLSearchParams(window.location.search)
  const companyId = params.get('company_id')
  const costCenterId = params.get('cost_center_id')
  // const screenId = params.get('screen_id')

  if (!companyId || !costCenterId) { // || !screenId
    return
  }

  next()
})

export default router
